import { render } from "./list.vue?vue&type=template&id=0642fa8a"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=0642fa8a&lang=css"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__